import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppBar as MuiAppBar, Box, Divider, Toolbar as MuiToolbar } from '@mui/material'
import PropTypes from 'prop-types'

import { useGetStoreSettingsQuery } from '@/app/services/organisation'
import { selectOrganisationId } from '@/app/slices/organisationSlice'
import { Paths } from '@/common/utils'

import AppLogo from './AppLogo'

const classes = {
    appBar: {
        backgroundColor: 'white',
        color: 'white',
    },
    appBarLogo: {
        height: 32,
        boxSizing: 'content-box',
        cursor: 'pointer',
    },
    appBarItems: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        flex: 1,
    },
    appBarDivider: {
        marginInline: '16px',
    },
}

const AppBar = ({ color = 'default', position = 'sticky' }) => {
    const navigate = useNavigate()

    const organisationId = useSelector(selectOrganisationId)

    const { data: storeSettings } = useGetStoreSettingsQuery({
        organisationId,
    })

    return (
        <MuiAppBar
            color={color}
            position={position}
            sx={classes.appBar}
        >
            <MuiToolbar sx={{ paddingBlock: 1 }}>
                <AppLogo
                    logoUrl={storeSettings?.webStoreLogoUri}
                    sx={classes.appBarLogo}
                    onClick={() => {
                        navigate(Paths.HOME_PATHNAME)
                    }}
                />

                {storeSettings?.webStoreLogoUri ? (
                    <Divider
                        orientation="vertical"
                        sx={classes.appBarDivider}
                        flexItem
                    />
                ) : null}

                <Box
                    id="app-bar"
                    sx={classes.appBarItems}
                ></Box>
            </MuiToolbar>
        </MuiAppBar>
    )
}

AppBar.propTypes = {
    color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),
    position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
}

export default AppBar
